__turbopack_context__.v({
  "className": "dm_sans_e18262d2-module__VGNg0W__className",
  "variable": "dm_sans_e18262d2-module__VGNg0W__variable",
});
